import { Engagement, TerminationState } from "@oysterhr/schema"
import { useTranslation } from "react-i18next"
import { HiringBlockStepType } from "~/app/utils/constants"
import { HiringStepBlock } from "~/app/components/Hiring/HiringStepBlock"
import { Back } from "@oysterhr/feature-components"
import { useState } from "react"
import { Button } from "@oysterhr/ui"
import { CancelOffboardingModal } from "./CancellationModals/Offboarding"

const data = {
  company: [
    {
      stepKey: "step1",
      type: HiringBlockStepType.ACTIVE,
      approx: "1-2",
    },
    {
      stepKey: "step11",
      type: HiringBlockStepType.PASSIVE,
      approx: "1-2",
    },
    {
      stepKey: "step12",
      type: HiringBlockStepType.PASSIVE,
      approx: "1-2",
    },
    {
      stepKey: "step13",
      type: HiringBlockStepType.PASSIVE,
      approx: "1-2",
    },
    {
      stepKey: "step2",
      type: HiringBlockStepType.ACTIVE,
      approx: 1,
    },
    {
      stepKey: "step21",
      type: HiringBlockStepType.PASSIVE,
      approx: 1,
    },
    {
      stepKey: "step3",
      type: HiringBlockStepType.ACTIVE,
      approx: "1-2",
    },
    {
      stepKey: "step31",
      type: HiringBlockStepType.PASSIVE,
      approx: 1,
    },
  ],
  teamMember: [
    {
      stepKey: "step1",
      type: HiringBlockStepType.ACTIVE,
      approx: "2-3",
    },
    {
      stepKey: "step2",
      type: HiringBlockStepType.ACTIVE,
      approx: "2-3",
    },
    {
      stepKey: "step22",
      type: HiringBlockStepType.PASSIVE,
      approx: "1-2",
    },
    {
      stepKey: "step3",
      type: HiringBlockStepType.ACTIVE,
      approx: "1-2",
    },
    {
      stepKey: "step31",
      type: HiringBlockStepType.PASSIVE,
      approx: 1,
    },
  ],
}

interface OffboardingHighwayProps {
  engagement: Engagement
  showHighwayView: (show: boolean) => void
  refetch: () => void
}

export const OffboardingHighwayOld = ({
  engagement,
  showHighwayView,
  refetch,
}: OffboardingHighwayProps) => {
  const { t } = useTranslation("colleague_interface/EmployeeProfilePage")
  const [showTerminationCancelModal, setShowTerminationCancelModal] = useState(false)

  if (engagement?.isPayrollTeamMember) {
    return null
  }
  return (
    <>
      {showTerminationCancelModal && (
        <CancelOffboardingModal
          engagement={engagement}
          setShowModal={setShowTerminationCancelModal}
          refetch={refetch}
          performedByStaff={false}
          showHighwayView={showHighwayView}
        />
      )}
      <div className="text-left">
        <div className="mx-12 flex justify-between">
          <Back onClick={() => showHighwayView(false)} noMargin={true}>
            <span className="text-primary-base underline">
              {t("offboarding.offboardingHighway.back")}
            </span>
          </Back>
          {engagement.termination?.state === TerminationState.Initiated && (
            <Button onClick={() => setShowTerminationCancelModal(true)} variation="secondary">
              <div className="mx-2 space-x-2">
                <span>{t("offboarding.offboardingHighway.cancelOffboarding")}</span>
              </div>
            </Button>
          )}
        </div>
        <div className="mx-8 lg:flex">
          <div className="mt-8 rounded-lg border-2 border-gray-200 bg-white p-2 md:p-8 lg:flex-1">
            <div className="text-lg font-semibold">
              {t("offboarding.offboardingHighway.companyProcess")}
            </div>
            {data.company.map(step => {
              return (
                <div key={step.stepKey} className="mt-8">
                  <HiringStepBlock
                    number={step.type === HiringBlockStepType.ACTIVE && step.stepKey.slice(-1)}
                    title={t(`offboarding.offboardingHighway.company.${step.stepKey}.title`)}
                    description={t(
                      `offboarding.offboardingHighway.company.${step.stepKey}.description`,
                    )}
                    readonly
                  />
                </div>
              )
            })}
          </div>
          <div className="mt-8 rounded-lg bg-gray-200 p-2 md:p-8 lg:ml-8 lg:flex-1">
            <div className="text-lg font-semibold">
              {t("offboarding.offboardingHighway.teamMemberProcess")}
            </div>
            <div className="mt-8">
              {t("offboarding.offboardingHighway.teamMember.description1")}
            </div>
            {data.teamMember.map(step => {
              return (
                <div key={step.stepKey} className="mt-8">
                  <HiringStepBlock
                    number={step.type === HiringBlockStepType.ACTIVE && step.stepKey.slice(-1)}
                    title={t(`offboarding.offboardingHighway.teamMember.${step.stepKey}.title`)}
                    description={t(
                      `offboarding.offboardingHighway.teamMember.${step.stepKey}.description`,
                    )}
                    readonly
                  />
                </div>
              )
            })}
            <div className="mt-8 flex flex-row items-center space-x-3 rounded-md bg-info-lighten-100 p-4 text-info-base">
              {t("offboarding.offboardingHighway.teamMemberInfo")}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
